import {
    useMemo,
} from 'react'
import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import useTabsByPermission from 'app/hooks/useTabsByPermission'
import {
    RequestKeys,
} from 'app/hooks/useRequest'

import useForecastRoutes from 'app/SkyNetRoutes/hooks/useForecastRoutes'
import requests from 'app/requests/Forecast/Forecast.requests'
import useHasPermission from 'app/hooks/useHasPermission/useHasPermission'

import tableConfig from './ShortTermForecasts.config'
import ShortTermForecastOverview from './ShortTermForecastOverview'
import ShortTermForecastCsvUpload from './ShortTermForecastCsvUpload'

const ShortTermForecasts = () => {
    const canCreate = useHasPermission(['forecast_create'])

    const {
        ShortTermForecast: ShortTermForecastRoutes,
    } = useForecastRoutes()

    const tabs: SidebarTab[] = useTabsByPermission([{
        tab: {
            label: 'Overview',
            url: ShortTermForecastRoutes.Overview.route,
            Component: ShortTermForecastOverview,
        },
        permission: true,
    }])

    const tableControls: TableControlTypes[] = useMemo(() => {
        const controls = [
            canCreate && TableControlTypes.CsvUpload,
            TableControlTypes.ClearFilters,
            TableControlTypes.ClearSorting,
        ]

        return controls.filter(Boolean)
    }, [canCreate])

    return (
        <SkyNetDomain
            name={tableConfig.name}
            sidebarTabs={tabs}
            defaultTab="overview"
            getDomainObject={requests.get}
            domainRequestKey={RequestKeys.getForecastById}
            actionComponents={{
                CsvUpload: canCreate ? ShortTermForecastCsvUpload : undefined,
            }}
        >
            <SkyNetTable
                customUrl={requests.filterRequest().url}
                tableControls={tableControls}
                tableConfig={tableConfig}
                showSearch
            />
        </SkyNetDomain>

    )
}

export default ShortTermForecasts
